import { useDealModelMode, usePutDealModelMode } from '../api/queries'
import { experiences, specForMode, type ExperienceId, type ExperienceSpec } from './registry'

export interface ExperienceState {
  spec: ExperienceSpec
  active: ExperienceId
  /** Experiences the backend currently serves, in registry order. */
  available: ExperienceSpec[]
  ready: boolean
  switching: boolean
  error: string | null
  switchTo: (id: ExperienceId) => void
}

export function useExperience(): ExperienceState {
  const mode = useDealModelMode()
  const put = usePutDealModelMode()
  const spec = specForMode(mode.data?.activeMode)
  const served = new Set<string>(mode.data?.availableModes ?? [])
  const available = Object.values(experiences).filter(candidate => served.has(candidate.modeKey))
  return {
    spec,
    active: spec.id,
    available,
    ready: mode.isSuccess,
    switching: put.isPending,
    error: put.error?.message ?? mode.error?.message ?? null,
    switchTo: (id) => {
      const target = experiences[id]
      if (!mode.data || target.modeKey === mode.data.activeMode || !served.has(target.modeKey)) return
      put.mutate({ expectedRevision: mode.data.preferenceRevision, mode: target.modeKey as 'investor' | 'homeBuyer' })
    },
  }
}
